import React, { useState } from 'react';
import subAgent from "../../assets/img/subagent.svg";
import Button from "react-bootstrap/Button";
import loading_gif from "../../assets/img/22.gif";

interface AccordionProps {
  index: number;
  formatTimeDifference: (date: any) => string;
  item: any;
  data: any;
  handleShowModal: (
    item: any,
    data: any,
    index?: any
  ) => void;
}

const Accordion: React.FC<AccordionProps> = ({ index, item, data, formatTimeDifference, handleShowModal }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="accordion accourdion-nested-chat"
      id="accordionExample"
    >
      <div className="accordion-item">
        <h2
          className="accordion-header"
          id="headingOne"
        >
          <button
            className={`accordion-button ${isOpen ? '' : 'collapsed'}`}
            type="button"
            onClick={toggleAccordion}
          >
            <span className="step-text">
              Task
            </span>{" "}
            performed in background
          </button>
          <div className="justnow-status">
            {formatTimeDifference(
              item?.insert_date_
            )}
          </div>
        </h2>
        <div
          id={`collapseOne-${index}`}
          className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
          aria-labelledby="headingOne"
        >
          <div className="accordion-body">
            <div className="user-chat-details">
              <div className="user-chat-img">
                <img
                  src={
                    /^:.*:$/.test(item?.content?.message?.chain_config?.emoji ?? "")
                      ? subAgent
                      : item?.content?.message?.chain_config?.emoji || subAgent
                  }
                  alt="User"
                />

               
              </div>
             
              <div className="user-chat-content">
                <div className="user-chat-title">
                  <div className="chat-title">
                    {item?.content?.message
                      ?.chain_config?.type ===
                    "tool"
                      ? "Used"
                      : "Delegated to"}{" "}
                    <span>
                      {
                        item?.content?.message
                          ?.chain_config?.title
                      }
                    </span>
                  </div>
                  <div className="miutes-ago">
                    {formatTimeDifference(
                      item?.insert_date_
                    )}
                  </div>
                </div>
                {item?.content?.message?.chain_config?.type !== "tool" && (
                <div>
                  {/* <Button
                    variant="primary"
                    onClick={() =>
                      handleShowModal(
                        item,
                        data,
                        index
                      )
                    }
                  >
                    View conversation
                  </Button> */}
                </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
